
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 2.27.0
 * Query Engine version: b8c35d44de987a9691890b3ddf3e2e7effb9bf20
 */
Prisma.prismaVersion = {
  client: "2.27.0",
  engine: "b8c35d44de987a9691890b3ddf3e2e7effb9bf20"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */

Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.UserScalarFieldEnum = makeEnum({
  checkLocationOnLogin: 'checkLocationOnLogin',
  countryCode: 'countryCode',
  createdAt: 'createdAt',
  gender: 'gender',
  id: 'id',
  name: 'name',
  notificationEmail: 'notificationEmail',
  password: 'password',
  prefersLanguage: 'prefersLanguage',
  prefersColorScheme: 'prefersColorScheme',
  prefersReducedMotion: 'prefersReducedMotion',
  prefersEmailId: 'prefersEmailId',
  profilePictureUrl: 'profilePictureUrl',
  role: 'role',
  timezone: 'timezone',
  twoFactorMethod: 'twoFactorMethod',
  twoFactorPhone: 'twoFactorPhone',
  twoFactorSecret: 'twoFactorSecret',
  attributes: 'attributes',
  updatedAt: 'updatedAt',
  active: 'active',
  isRegisteredWithGoogle: 'isRegisteredWithGoogle',
  slug: 'slug'
});

exports.Prisma.GroupScalarFieldEnum = makeEnum({
  autoJoinDomain: 'autoJoinDomain',
  createdAt: 'createdAt',
  forceTwoFactor: 'forceTwoFactor',
  forceBranding: 'forceBranding',
  showYalendarBranding: 'showYalendarBranding',
  id: 'id',
  ipRestrictions: 'ipRestrictions',
  name: 'name',
  slug: 'slug',
  onlyAllowDomain: 'onlyAllowDomain',
  profilePictureUrl: 'profilePictureUrl',
  attributes: 'attributes',
  updatedAt: 'updatedAt',
  parentId: 'parentId',
  stripeCustomerId: 'stripeCustomerId',
  stripeProductId: 'stripeProductId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  stripeSubscriptionStatus: 'stripeSubscriptionStatus',
  plan: 'plan',
  publicBio: 'publicBio',
  publicBannerUrl: 'publicBannerUrl'
});

exports.Prisma.EmailScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  email: 'email',
  emailSafe: 'emailSafe',
  id: 'id',
  isVerified: 'isVerified',
  updatedAt: 'updatedAt',
  userId: 'userId'
});

exports.Prisma.ApiKeyScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  description: 'description',
  id: 'id',
  ipRestrictions: 'ipRestrictions',
  apiKey: 'apiKey',
  name: 'name',
  groupId: 'groupId',
  referrerRestrictions: 'referrerRestrictions',
  scopes: 'scopes',
  updatedAt: 'updatedAt',
  userId: 'userId'
});

exports.Prisma.ApprovedSubnetScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  id: 'id',
  subnet: 'subnet',
  city: 'city',
  region: 'region',
  timezone: 'timezone',
  countryCode: 'countryCode',
  updatedAt: 'updatedAt',
  userId: 'userId'
});

exports.Prisma.BackupCodeScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isUsed: 'isUsed',
  userId: 'userId'
});

exports.Prisma.CouponCodeScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  maxUses: 'maxUses',
  usedCount: 'usedCount',
  teamRestrictions: 'teamRestrictions',
  amount: 'amount',
  currency: 'currency',
  description: 'description'
});

exports.Prisma.DomainScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  domain: 'domain',
  id: 'id',
  isVerified: 'isVerified',
  groupId: 'groupId',
  updatedAt: 'updatedAt',
  verificationCode: 'verificationCode'
});

exports.Prisma.IdentityScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  id: 'id',
  loginName: 'loginName',
  type: 'type',
  updatedAt: 'updatedAt',
  userId: 'userId'
});

exports.Prisma.MembershipScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  id: 'id',
  groupId: 'groupId',
  role: 'role',
  updatedAt: 'updatedAt',
  userId: 'userId'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  id: 'id',
  ipAddress: 'ipAddress',
  token: 'token',
  updatedAt: 'updatedAt',
  userAgent: 'userAgent',
  city: 'city',
  region: 'region',
  timezone: 'timezone',
  countryCode: 'countryCode',
  browser: 'browser',
  operatingSystem: 'operatingSystem',
  userId: 'userId'
});

exports.Prisma.WebhookScalarFieldEnum = makeEnum({
  contentType: 'contentType',
  createdAt: 'createdAt',
  event: 'event',
  id: 'id',
  isActive: 'isActive',
  lastFiredAt: 'lastFiredAt',
  lastRunResult: 'lastRunResult',
  groupId: 'groupId',
  secret: 'secret',
  updatedAt: 'updatedAt',
  url: 'url'
});

exports.Prisma.AuditLogScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  event: 'event',
  rawEvent: 'rawEvent',
  eventData: 'eventData',
  id: 'id',
  groupId: 'groupId',
  updatedAt: 'updatedAt',
  userId: 'userId',
  apiKeyId: 'apiKeyId',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  city: 'city',
  region: 'region',
  timezone: 'timezone',
  countryCode: 'countryCode',
  browser: 'browser',
  operatingSystem: 'operatingSystem'
});

exports.Prisma.CredentialScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  key: 'key',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.CalendarTypeCustomInputScalarFieldEnum = makeEnum({
  id: 'id',
  idCalendarType: 'idCalendarType',
  label: 'label',
  helpText: 'helpText',
  options: 'options',
  type: 'type',
  required: 'required',
  placeholder: 'placeholder'
});

exports.Prisma.CalendarTypeScalarFieldEnum = makeEnum({
  id: 'id',
  groupId: 'groupId',
  name: 'name',
  eventNameFormat: 'eventNameFormat',
  locations: 'locations',
  active: 'active',
  isSecret: 'isSecret',
  internalNote: 'internalNote',
  description: 'description',
  slug: 'slug',
  durationInMinutes: 'durationInMinutes',
  breakAfterEventInMinutes: 'breakAfterEventInMinutes',
  colorInHexadecimal: 'colorInHexadecimal',
  timezone: 'timezone',
  schedulingType: 'schedulingType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disableGuests: 'disableGuests',
  imageUrl: 'imageUrl',
  showHostAvatar: 'showHostAvatar',
  slotIncrementInMinutes: 'slotIncrementInMinutes',
  appointmentsLimitPerDay: 'appointmentsLimitPerDay',
  price: 'price',
  currency: 'currency',
  requiresConfirmation: 'requiresConfirmation',
  periodType: 'periodType',
  periodStartDate: 'periodStartDate',
  periodEndDate: 'periodEndDate',
  periodDays: 'periodDays',
  periodCountCalendarDays: 'periodCountCalendarDays'
});

exports.Prisma.SelectedCalendarScalarFieldEnum = makeEnum({
  userId: 'userId',
  integration: 'integration',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DestinationCalendarScalarFieldEnum = makeEnum({
  id: 'id',
  integration: 'integration',
  externalId: 'externalId',
  name: 'name',
  userId: 'userId',
  appointmentId: 'appointmentId',
  calendarTypeId: 'calendarTypeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.AvailabilityScalarFieldEnum = makeEnum({
  id: 'id',
  idCalendarType: 'idCalendarType',
  userId: 'userId',
  wDay: 'wDay',
  date: 'date',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.AvailabilityIntervalScalarFieldEnum = makeEnum({
  id: 'id',
  idAvailability: 'idAvailability',
  startTime: 'startTime',
  endTime: 'endTime',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.AppointmentScalarFieldEnum = makeEnum({
  id: 'id',
  idCalendarType: 'idCalendarType',
  userId: 'userId',
  title: 'title',
  startTime: 'startTime',
  endTime: 'endTime',
  guestName: 'guestName',
  guestEmail: 'guestEmail',
  location: 'location',
  additionalInfos: 'additionalInfos',
  rescheduleReason: 'rescheduleReason',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paid: 'paid',
  confirmed: 'confirmed',
  rejected: 'rejected'
});

exports.Prisma.AppointmentReferenceScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  uid: 'uid',
  meetingId: 'meetingId',
  meetingPassword: 'meetingPassword',
  meetingUrl: 'meetingUrl',
  appointmentId: 'appointmentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.AttendeeScalarFieldEnum = makeEnum({
  id: 'id',
  idAppointment: 'idAppointment',
  email: 'email',
  name: 'name',
  timeZone: 'timeZone'
});

exports.Prisma.CalendarAssignmentScalarFieldEnum = makeEnum({
  id: 'id',
  idCalendarType: 'idCalendarType',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active'
});

exports.Prisma.PaymentScalarFieldEnum = makeEnum({
  id: 'id',
  uid: 'uid',
  type: 'type',
  appointmentId: 'appointmentId',
  amount: 'amount',
  fee: 'fee',
  currency: 'currency',
  success: 'success',
  refunded: 'refunded',
  data: 'data',
  externalId: 'externalId'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});
exports.Gender = makeEnum({
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  NONBINARY: 'NONBINARY',
  UNKNOWN: 'UNKNOWN'
});

exports.NotificationEmail = makeEnum({
  ACCOUNT: 'ACCOUNT',
  UPDATES: 'UPDATES',
  PROMOTIONS: 'PROMOTIONS'
});

exports.PrefersColorScheme = makeEnum({
  NO_PREFERENCE: 'NO_PREFERENCE',
  LIGHT: 'LIGHT',
  DARK: 'DARK'
});

exports.PrefersReducedMotion = makeEnum({
  NO_PREFERENCE: 'NO_PREFERENCE',
  REDUCE: 'REDUCE'
});

exports.UserRole = makeEnum({
  SUDO: 'SUDO',
  USER: 'USER'
});

exports.MfaMethod = makeEnum({
  NONE: 'NONE',
  SMS: 'SMS',
  TOTP: 'TOTP',
  EMAIL: 'EMAIL'
});

exports.GroupPlan = makeEnum({
  FREE: 'FREE',
  TRIAL: 'TRIAL',
  PRO: 'PRO'
});

exports.IdentityType = makeEnum({
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE',
  SLACK: 'SLACK'
});

exports.MembershipRole = makeEnum({
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
});

exports.CalendarTypeCustomInputType = makeEnum({
  TEXT: 'TEXT',
  TEXTLONG: 'TEXTLONG',
  NUMBER: 'NUMBER',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  FILE: 'FILE'
});

exports.SchedulingType = makeEnum({
  ROUND_ROBIN: 'ROUND_ROBIN',
  COLLECTIVE: 'COLLECTIVE'
});

exports.PeriodType = makeEnum({
  UNLIMITED: 'UNLIMITED',
  ROLLING: 'ROLLING',
  RANGE: 'RANGE'
});

exports.WeekDay = makeEnum({
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY'
});

exports.AppointmentStatus = makeEnum({
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED'
});

exports.PaymentType = makeEnum({
  STRIPE: 'STRIPE'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Group: 'Group',
  Email: 'Email',
  ApiKey: 'ApiKey',
  ApprovedSubnet: 'ApprovedSubnet',
  BackupCode: 'BackupCode',
  CouponCode: 'CouponCode',
  Domain: 'Domain',
  Identity: 'Identity',
  Membership: 'Membership',
  Session: 'Session',
  Webhook: 'Webhook',
  AuditLog: 'AuditLog',
  Credential: 'Credential',
  CalendarTypeCustomInput: 'CalendarTypeCustomInput',
  CalendarType: 'CalendarType',
  SelectedCalendar: 'SelectedCalendar',
  DestinationCalendar: 'DestinationCalendar',
  Availability: 'Availability',
  AvailabilityInterval: 'AvailabilityInterval',
  Appointment: 'Appointment',
  AppointmentReference: 'AppointmentReference',
  Attendee: 'Attendee',
  CalendarAssignment: 'CalendarAssignment',
  Payment: 'Payment'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
